import React from 'react';
import qs from 'qs';
import { Redirect } from 'react-router-dom';

export default ({location}) => {
  const q = qs.parse(location.search, {ignoreQueryPrefix: true});  
  return <Redirect to={`/rescue/reset?token=${q.token}`}/>;
}